// extracted by mini-css-extract-plugin
export default {"box":"styles_box__XYK5I","hover":"styles_hover__57GeW"};